import React, {Component} from 'react';
import * as messageConstants from '../../../shared/messages';
import * as samlConstants from '../../../constants/samlConstants';

export class UserAttributesEnum extends Component {

  handleValueChange = (e) => {
    this.props.onUserAttributesTableUpdate(e);
  }

  render() {
    return (
        <select
            name={this.props.cellData.type}
            value={this.props.cellData.value}
            id={this.props.cellData.id}
            onChange={this.handleValueChange}
            className="attributes-dropdown  form-control">
          <option value={samlConstants.EMAIL}>{messageConstants.EMAIL}</option>
          <option
              value={samlConstants.FIRST_NAME}>{messageConstants.FIRST_NAME}</option>
          <option
              value={samlConstants.LAST_NAME}>{messageConstants.LAST_NAME}</option>
          <option
              value={samlConstants.CUSTOM_ATTRIBUTE}>{messageConstants.CUSTOM_ATTRIBUTE}</option>
          <option
              value={samlConstants.DOMAIN}>{messageConstants.DOMAIN}</option>
          <option
              value={samlConstants.USER_PRINCIPAL_NAME}>{messageConstants.USER_PRINCIPAL_NAME}</option>
          <option
              value={samlConstants.USER_DISPLAY_NAME}>{messageConstants.USER_DISPLAY_NAME}</option>
          {this.props.displayUserExtendedAttributes ? <option
                    value={samlConstants.NET_BIOS_SAM_ACCOUNT_NAME}>{messageConstants.NET_BIOS_SAM_ACCOUNT_NAME}</option>
              : null}
          {this.props.displayFlexibleAttributes ? <option
              value={samlConstants.OBJECT_SID}>{messageConstants.OBJECT_SID}</option>
              : null}
          {this.props.displayFlexibleAttributes ? <option
              value={samlConstants.OBJECT_GUID}>{messageConstants.OBJECT_GUID}</option>
              : null}
          <option
              value={samlConstants.USER_ID}>{messageConstants.USER_ID}</option>
            {this.props.displayUserExtendedAttributes && this.props.extendedAttributes ?
                Object.keys(this.props.extendedAttributes).map(extendedAttribute =>
          <option key={extendedAttribute}
              value={extendedAttribute}>{extendedAttribute} ({this.props.extendedAttributes[extendedAttribute].join(", ")})</option>)
                : null}
        </select>
    );
  }
}

export default UserAttributesEnum;
